import styled from 'styled-components';

export const Link = styled.a`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: inherit;
`;

export const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 44px;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
